<template>
  <div :class="orderType ? 'isComp list' : 'list'">
    <!-- filter -->
    <div class="list-filter" v-if="$props.orderType == 39">
      <!-- <div class="filter-date" @click="showPopupStatus = true">
        <span>{{ formData.mealStr || $t("select_meal") }}</span>
        <van-icon name="arrow-down" />
      </div> -->
      <div class="filter-status" @click="showPopupStatus = true">
        <span>{{ formData.statusStr || $t("reserve_status") }}</span>
        <van-icon name="arrow-down" />
      </div>
    </div>
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="$t('noMore')"
      :loading-text="$t('loading')"
      @load="onLoad"
    >
      <div>
        <div
          v-for="(item, index) in orderList"
          :key="index"
          @click="handleOrderDetail(item)"
        >
          <div
            class="recharge-order"
            v-if="item.orderType == 7 || item.orderType == 2"
          >
            <div class="order-top">
              <div class="order-type">
                {{
                  language == "CN"
                    ? item.branchName
                    : item.branchName || item.branchName
                }}
              </div>
              <div
                class="order-state"
                :style="{
                  color:
                    item.reserveStatus == '4'
                      ? '#09ACF8'
                      : item.reserveStatus == '10'
                      ? '#00C442'
                      : item.reserveStatus == '11'
                      ? '#F60303'
                      : item.reserveStatus == '12'
                      ? '#F49800'
                      : '#666666',
                }"
              >
                {{ item.reserveStatusName }}
              </div>
            </div>
            <div class="order-countal">
              <div class="order-count">
                <div>{{ $t("orderNo") }}：{{ item.orderNo }}</div>
                <div>{{ $t("orderTime") }}：{{ item.payTime }}</div>
              </div>
              <div class="order-price">
                <div>{{ $t("totalCount", [item.totalQuantity]) }}</div>
                <div class="order-price-realFee">
                  ￥{{ (item.realFee / 100).toFixed(2) }}
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="order-data">
              <div class="order-head">
                <div>
                  <div class="order-n">
                    {{
                      language == "CN"
                        ? item.branchName
                        : item.branchName || item.branchName
                    }}
                  </div>
                  <div class="order-time">
                    {{ item.targetDate }}
                    {{
                      language == "CN" ? item.mealHourName : item.mealHourNameEn
                    }}
                  </div>
                </div>
                <div
                  class="order-state"
                  :style="{
                    color:
                      item.reserveStatus == '4'
                        ? '#09ACF8'
                        : item.reserveStatus == '10'
                        ? '#00C442'
                        : item.reserveStatus == '11'
                        ? '#F60303'
                        : item.reserveStatus == '12'
                        ? '#F49800'
                        : '#666666',
                  }"
                >
                  {{ item.reserveStatusName }}
                </div>
              </div>
              <div class="order-center">
                <div class="order-shopname">
                  <div
                    class="shop-main"
                    v-for="i in item.orderItemList"
                    :key="i.productid"
                  >
                    <img
                      :src="i.productPic || require('../../assets/noimg.jpeg')"
                      alt=""
                    />
                    <div class="meal-num">x{{ i.quantity }}</div>
                  </div>
                </div>
                <div class="total-price-main">
                  <div class="pieces-total">
                    {{ $t("totalCount", [item.totalQuantity]) }}
                  </div>
                  <div class="price">
                    ￥{{ (item.realFee / 100).toFixed(2) }}
                  </div>
                </div>
              </div>
              <div class="order-footer">
                <div
                  class="mini-btn"
                  v-if="
                    !orderType ||
                    (orderType == 39 &&
                      (item.reserveStatus == '11' ||
                        item.reserveStatus == '10'))
                  "
                  @click.stop="handleMoreOrder(item)"
                >
                  {{ $t("oneOrder") }}
                </div>
                <div
                  v-if="
                    orderType == 39 &&
                    item.reserveStatus != '10' &&
                    item.reserveStatus != '11' &&
                    item.reserveStatus != '12'
                  "
                  style="margin-left: 5px"
                  class="mini-btn"
                  @click.stop="handleCancelOrder(item)"
                >
                  {{ $t("cancelOrder") }}
                </div>
                <div
                  v-if="orderType == 39 && item.reserveStatus == '12'"
                  style="margin-left: 5px"
                  class="mini-btn"
                  @click.stop="handleRepayOrder(item)"
                >
                  {{ $t("repayBtn") }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-list>

    <van-popup v-model="showPopupStatus" round position="bottom">
      <van-picker
        show-toolbar
        :columns="statusList"
        @cancel="showPopupStatus = false"
        @confirm="onConfirmStatus"
      />
    </van-popup>
    <van-popup v-model="showPopupMeal" round position="bottom">
      <van-picker
        show-toolbar
        :columns="mealList"
        @cancel="showPopupMeal = false"
        @confirm="onConfirmMeal"
      />
    </van-popup>
  </div>
</template>
<script>
import { Dialog } from "vant";
import dayjs from "dayjs";
export default {
  components: {},
  props: ["orderType"],
  data() {
    return {
      loading: false,
      finished: false,
      orderList: [],
      lastOrderNo: "",
      handleBooer: true,
      orderNo: "",
      shopId: "",
      customerId: "",
      invoiceConfig: {
        isShow: false,
      },
      pageForm: {
        page: 0,
        size: 10,
      },
      language: "",
      formData: {},
      showPopupStatus: false,
      statusList: [
        {
          text: this.$t("deliveryStr1"),
          value: -1,
        },
        {
          text: this.$t("orderStatus04"),
          value: 4,
        },
        {
          text: this.$t("statusStr2"),
          value: 11,
        },
      ],
      showPopupMeal: false,
      mealList: [],
    };
  },
  watch: {},
  created() {
    this.shopId = localStorage.getItem("shopId");
    this.language = localStorage.getItem("language");
    let roles = JSON.parse(localStorage.getItem("customerInfoList"));
    this.customerId =
      (roles && roles[0].customerId) || localStorage.getItem("customerId");

    // SHOP_INVOICE_CONFIG

    this.getInvoiceConfig();
  },
  mounted() {
  },
  activated() {},
  methods: {
    onConfirmStatus(e) {
      this.$set(this.formData, "statusStr", e.text);
      this.$set(this.formData, "reserveStatus", e.value);
      this.showPopupStatus = false;
      this.reload(true);
    },
    onConfirmMeal(e) {
      this.$set(this.formData, "mealStr", e.text);
      this.$set(this.formData, "mealHourId", e.value);
      this.showPopupMeal = false;
      this.reload(true);
    },
    async getInvoiceConfig() {
      let reqData = {
        shopId: this.shopId,
        paramName: "SHOP_INVOICE_CONFIG",
      };
      const rq = {
        shopId: this.shopId,
        customerId: this.customerId,
      };
      const { data: resData } = await this.$logina.post(
        "/api/customer/getBalanceV3",
        rq
      );
      if (resData.code != 200) {
        this.$toast(resData.message);
        return;
      }

      const userInfo = resData.data;

      const res = await this.$authAjax.post("/api/shop/getShopConfig", reqData);
      let resData1 = res.data;
      if (resData1.code != 200) {
        return;
      }

      // console.log('res', );
      const config = resData1.data.configList[0];
      if (!config || !config.paramValue) {
        console.log("configList---<<<< error", config);
        return;
      }
      console.log("configList", config);
      const paramValue = JSON.parse(config.paramValue);
      const groupIds = paramValue.groupIds || [];
      this.invoiceConfig = {
        ...paramValue,
        isShow: !groupIds.length || groupIds.includes(userInfo.customerGroupId),
      };
    },
    getOrderList() {
      this.pageForm.page += 1;
      const orderTypeIds = this.$props?.orderType
        ? [this.$props.orderType]
        : [16];
      console.log(this.pageForm.page, "this.pageForm.page");
      let data = {
        orderTypeIds,
        ...this.pageForm,
        startTime: dayjs(new Date()).format("YYYY-MM-DD 00:00:00"),
        endTime: dayjs(new Date()).format("YYYY-MM-DD 23:59:59"),
        ...this.formData,
        orderByMeal: this.$props?.orderType ? 1 : undefined
      };
      const that = this;
      this.$authAjax
        .post("/api/wxapp/customer/reserve/orderList", data)
        .then((res) => {
          let { data } = res.data;
          console.log(data.rows, "orderlist");
          if (data.rows.length && data.totalPage >= that.pageForm.page) {
            that.orderList = [...that.orderList, ...data.rows];
            that.loading = false;
          } else {
            that.finished = true;
          }
        })
        .finally(() => {
          that.loading = false;
        })
        .catch(() => {
          that.finished = true;
        });
    },
    onLoad() {
      if (this.orderList && this.orderList.length > 0) {
        this.lastOrderNo = this.orderList[this.orderList.length - 1].orderNo;
      }
      this.getOrderList();
    },
    reload(flag = false) {
      this.orderList = [];
      this.pageForm.page = 0;
      flag && this.getOrderList();
    },
    //订单详情
    handleOrderDetail(data) {
      this.$router.push({
        path: "/order/detail",
        query: {
          orderNo: data.orderNo,
          orderType: this.orderType,
        },
      });
    },
    //取消订单
    handleCancelOrder(item) {
      this.orderNo = item.orderNo;
      Dialog.confirm({
        message: this.$t("cancelOrderPlaceholder"),
      })
        .then(() => {
          let data = {
            orderNo: item.orderNo,
            shopId: this.shopId,
          };
          this.$authAjax
            .post("/api/wxapp/reserve/order/cancel", data)
            .then((res) => {
              if (res.data.code == 200) {
                this.$toast.success(this.$t("cancelSuccess"));
                this.lastOrderNo = "";
                this.reload(true);
              } else {
                this.$toast.fail(this.$t("cancelFinal"));
              }
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    // 再来一单
    async handleMoreOrder(item) {
      await Dialog.alert({
        allowHtml: true,
        message: this.$t("confirmOneTip"),
        showCancelButton: true,
        confirmButtonText: this.$t("confirm"),
        cancelButtonText: this.$t("orderCancel"),
        confirmButtonColor: "#419DFB",
      });

      let itemList = [];
      item.orderItemList?.map((meal) => {
        itemList.push({
          productId: meal.productId,
          productName: meal.productName,
          count: meal.quantity,
          price: meal.price,
          productAmount: meal.quantity,
        });
      });
      let requestData = {
        branchId: item.branchId,
        shopId: item.shopId,
        customerId: this.customerId,
        branchName: item.branchName,
        targetDate: dayjs(new Date()).format("YYYY-MM-DD"),
        levelNo: item.levelNo,
        addressId: item.addressId,
        orderDetails: itemList,
        note: item.note,
        mealHourId: item.mealHourId,
        mealHourName: item.mealHourName,
        reserveType: item.mealType,
        meal: item.isMeals ? true : false,
        warm: item.isWarm ? true : false,
        customerName: item.customerName,
        customerPhone: item.customerPhone,
        orderDetailList: itemList,
        orderType: item.orderType,
      };
      if (item.orderType === 39) {
        console.log(requestData, "requestData");
        this.$router.push({
          name: "packageForm",
          params: {
            againData: item,
          },
          query: {
            type: 39,
          },
        });
        return;
      } else {
        sessionStorage.setItem("branchId", item.branchId);
        this.$router.push({
          name: "cardPackage",
          params: {
            againData: item,
            type: 16,
          },
        });
        return;
      }

      // this.$toast.loading({
      //   message: this.language == "CN" ? "正在加载..." : "Loading...",
      //   forbidClick: true,
      //   loadingType: "spinner",
      // });
      // const { data: res } = await this.$authAjax.post(
      //   "/api/wxapp/new/reserve/order/create",
      //   requestData
      // );

      // await this.$authAjax.post("/api/wxapp/new/reserve/order/card/pay", {
      //   orderNo: res.data.orderNo,
      // });
      // this.$toast.success(this.$t("successTip"));
      // this.pageForm.page = 0;
      // this.orderList = [];
    },
    // 重新支付
    handleRepayOrder(item) {
      Dialog.confirm({
        message: this.$t("repayOrderPlaceholder"),
      })
        .then(async () => {
          const res = await this.$authAjax.get(
            "/api/wxapp/customer/groupPayAccount/list"
          );
          let { data } = res.data;
          console.log(data, "====");
          let groupPayRuleId = data?.[0]?.id;
          let workshopData = {
            orderNo: item.orderNo,
            groupPayRuleId,
          };
          await this.$authAjax.post(
            "/api/wxapp/new/reserve/order/group/pay",
            workshopData
          );
          this.$toast.success(this.$t("paySuccess"));
          this.reload(true);
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.isComp {
  padding: 10px 0 50px;
}
.list {
  // padding-top: 10px;
  background-color: #f8f8f8;
  height: 100vh;
  position: relative;
  overflow: auto;

  .shop-phone {
    height: 30px;
    background: #fff;
    font-size: 14px;
    color: #2ab1e7;
    text-align: center;
    line-height: 30px;
    position: sticky;
    top: 0;
    left: 0;
    margin-bottom: 10px;
    z-index: 99;
  }
  .recharge-order {
    padding: 12px;
    box-sizing: border-box;
    background: #ffffff;
    font-size: 14px;
    border-bottom: 1px solid #eee;
    .order-top {
      margin: 0 0px 8px 8px;
      display: flex;
      justify-content: space-between;
      .order-type {
        font-weight: bold;
        color: #333;
        margin-top: 5px;
        font-size: 16;
      }
      .order-state {
        color: #666;
        white-space: nowrap;
      }
    }
    .order-countal {
      display: flex;
      justify-content: space-between;
      .order-count {
        color: #999;
        margin: 6px 0 0 10px;
        font-size: 14px;
        div:nth-child(2) {
          margin-top: 4px;
        }
      }
      .order-price {
        margin-right: 10px;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        font-size: 12px;
        color: #666;
        div:nth-child(2) {
          margin-top: 2px;
        }
        .order-price-realFee {
          font-size: 16px;
          color: #ff0000;
          margin-top: 8px;
        }
      }
    }
  }
  .order-data {
    font-size: 12px;
    background: #ffffff;
    padding: 12px;
    box-sizing: border-box;
    border-bottom: 1px solid #eee;
    .order-head {
      margin: 0 0px 8px 8px;
      display: flex;
      justify-content: space-between;
      gap: 12px;
      .order-n {
        font-weight: bold;
        color: #333;
        margin-top: 6px;
      }
      .order-time {
        color: #666;
        font-size: 14px;
        margin-top: 8px;
      }
      .order-state {
        color: #666;
        font-size: 14px;
        white-space: nowrap;
        padding-top: 6px;
      }
    }
    .order-center {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .order-shopname {
        width: 280px;
        height: 60px;
        display: flex;
        align-items: center;
        overflow-x: auto;
        .shop-main {
          color: #999;
          margin-right: 5px;
          width: 48px;
          height: 48px;
          position: relative;
          img {
            width: 48px;
            height: 48px;
          }
          .meal-num {
            position: absolute;
            right: 0;
            bottom: 0;
            padding: 1px 3px;
            background: #999;
            font-size: 10px;
            color: #fff;
          }
        }
      }
      .total-price-main {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
      }
      .price {
        color: #ff0000;
        font-size: 16px;
        margin-top: 10px;
      }
      .pieces-total {
        font-size: 13px;
        color: #666;
      }
    }
    .order-footer {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .mini-btn {
        padding: 0 12px;
        margin-top: 12px;
        font-weight: bold;
        border: 1px solid #e6e6e6;
        border-radius: 5px;
        text-align: center;
        color: #333333;
        height: 30px;
        line-height: 30px;
      }
      .meal-num {
        font-size: 12px;
        font-weight: bold;
        margin-left: 10px;
        line-height: 3px;
        color: #2071c5;
      }
    }
  }
}
.list-filter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 16px 20px;
  border-bottom: 10px solid #f7f7f7;
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: #fff;

  .filter-date,
  .filter-status {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid rgba($color: #000000, $alpha: 0.1);
    border-radius: 6px;
    padding: 12px;
    color: #999999;

    font-size: 12px;

    span {
      flex: 1;
    }

    ::v-deep {
      .van-icon-todo-list-o {
        margin-right: 6px;
      }
    }
  }
}
</style>
